import axios from 'axios';

// Configuración base de Axios para los endpoints de Loyalty
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_LOYALTY_ENDPOINT, 
  headers: {
    'Accept': 'application/json'
  }
});

// Obtener la fecha de ayer 
const getDate = () => {
  const timeZone = 'America/Ciudad_Juarez';
  const now = new Date();
  const targetTimeStr = now.toLocaleString('en-US', { timeZone });
  const targetDate = new Date(targetTimeStr);

  // De forma temporal hacer una regresión de 30 días, dejar en un margen de 5 días para prod
  targetDate.setDate(targetDate.getDate() - 5);

  const year = targetDate.getFullYear();
  const month = String(targetDate.getMonth() + 1).padStart(2, '0');
  const day = String(targetDate.getDate()).padStart(2, '0');
  const time = "00:00:01";

  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    timeZoneName: 'longOffset'
  });
  const offsetString = formatter.formatToParts(targetDate).find(part => part.type === 'timeZoneName').value;
  
  const isoOffset = offsetString.replace('GMT', '') || 'Z';
  return `${year}-${month}-${day}T${time}${isoOffset}`;
};

const getYesterdayDate = () => getDate();
// Fecha para pruebas
// const getYesterdayDate = () => "2022-04-01 06:01:01";

export default {
  async getAccessToken() {
    const params = new URLSearchParams();
    params.append('grant_type', 'password');
    
    params.append('client_id', process.env.VUE_APP_LOYALTY_KC_CLIENT);
    params.append('username', process.env.VUE_APP_LOYALTY_KC_USER);
    params.append('password', process.env.VUE_APP_LOYALTY_KC_PASSWORD); 

    const authUrl = `${process.env.VUE_APP_LOYALTY_KC_SERVER}/auth/realms/${process.env.VUE_APP_LOYALTY_KC_REALM}/protocol/openid-connect/token`;

    try {
      const response = await axios.post(authUrl, params);
      return response.data.access_token;
    } catch (error) {
      console.error('Error de auth en Keycloak (Loyalty):', error.response?.data || error.message);
      throw error;
    }
  },

  async getCallcenterSummary(connectorId = 18) {
    try {
      const token = await this.getAccessToken();

      const response = await apiClient.get(`/callcenter/summary?connector_id=${connectorId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      return response.data;
    } catch (error) {
      console.error('Error al obtener summary de Callcenter:', error.response?.data || error.message);
      throw error;
    }
  },

  async getUsedVirtualCards(page = 1, dateSince = getYesterdayDate()) {
    try {
      const token = await this.getAccessToken();
      
      const response = await apiClient.get(`/callcenter/virtualCards?connector_id=18&used=true&page=${page}&createdSince=${dateSince}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      return response.data;
    } catch (error) {
      console.error('Error al obtener Virtual Cards:', error.response?.data || error.message);
      throw error;
    }
  },
  
  async getPendingCardsAsofarma(page = 1, dateSince = getYesterdayDate()) {
    try {
      const token = await this.getAccessToken();
      
      const endpoint = `/callcenter/virtualCards?connector_id=18&used=true&createdSince=${dateSince}&page=${page}`;
      
      const response = await apiClient.get(endpoint, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      return response.data;
    } catch (error) {
      console.error('Error al obtener tarjetas pendientes:', error.response?.data || error.message);
      throw error;
    }
  },
  
  async getTransInfo(cardBarcode, transactionDate) {
    try {
      const token = await this.getAccessToken();

      const response = await apiClient.get('/callcenter/transInfo', {
        params: {
          card: cardBarcode,
          date: transactionDate,
          connector_id: 18
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      return response.data;
    } catch (error) {
      console.error('Error al obtener info de la transacción (Mongo):', error.response?.data || error.message);
      throw error;
    }
  },

  // Alterna el estado de bloqueo de una tarjeta en el pool
  async toggleCardLock(barcode, isLocked) {
    const token = await this.getAccessToken();
    try {
      const response = await apiClient.post('callcenter/LockVc', {
        virtualCard: barcode,
        lock: isLocked
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error al cambiar el lock de la tarjeta:', error);
      throw error;
    }
  },

  // Agrega una tarjeta virtual al pool 
  async addVirtualCards(barcodes, originBarcode = null) { // Cambiamos a plural
      const token = await this.getAccessToken();
      const response = await apiClient.post('callcenter/addVirtualCard', {
          "connector_id": 18, 
          "barcodes": barcodes, // Esto debe ser un Array: ["123", "456"]
          ...(originBarcode && { "origin_barcode": originBarcode }) // Se inyecta solo si no es null
      }, {
          headers: { 'Authorization': `Bearer ${token}` }
      });
      
      return response.data;
  },

  // Dentro de tu objeto loyaltyApi
  async markCardAsFailed(barcode) {
      const token = await this.getAccessToken();
      const response = await apiClient.post('callcenter/markFailed', { barcode: barcode }, {
          headers: { 'Authorization': `Bearer ${token}` }
      });
      return response.data;
  },

  // Dentro de tu objeto loyaltyApi
  async checkCardStatus(barcode) {
      const token = await this.getAccessToken();
      const response = await apiClient.get(`callcenter/checkStatus/${barcode}`, {
          headers: { 'Authorization': `Bearer ${token}` }
      });
      return response.data;
  },
};